export default function useCampsiteMedia() {
  /********************
   * REFS & VARS       *
   ********************/
  const campsite = ref<Record<string, unknown>>({ media: [] });
  const mediaItemRefs = ref<Record<number, HTMLElement>>({});
  const selectedItemIdx = ref<number | null>(null);

  /********************
   * FUNCTIONS         *
   ********************/
  function onKeyUp(event: KeyboardEvent) {
    // ArrowLeft, ArrowRight, Escape
    if (event.key === 'ArrowLeft') {
      selectNextMediaItem(-1);
    } else if (event.key === 'ArrowRight') {
      selectNextMediaItem(1);
    } else if (event.key === 'Escape') {
      deselectCurrentMediaItem();
    }
  }

  function getMediaItemByMediaIdx(idx) {
    const items = campsite.value.media.filter(item => item.idx === idx);
    if (!items.length) {
      return null;
    }
    return items[0];
  }

  function getNextMediaItemIndex(idx: number | null, direction = 1): number | null {
    if (idx === null && direction === 1) {
      idx = -1;
    }

    let items = [];
    if (direction > 0) {
      items = campsite.value.media.filter(item => item.idx > idx);
    } else {
      items = campsite.value.media.filter(item => item.idx < idx);
    }
    if (!items.length) {
      return null;
    }
    if (direction > 0) {
      return items[0].idx;
    } else {
      return items[items.length - 1].idx;
    }
  }

  function selectNextMediaItem(direction) {
    const newIdx = getNextMediaItemIndex(selectedItemIdx.value, direction);
    if (newIdx === null) {
      return;
    }
    selectedItemIdx.value = newIdx;
    toggleSelectedMedia(
      getMediaItemByMediaIdx(selectedItemIdx.value),
      mediaItemRefs.value[selectedItemIdx.value]?.firstElementChild,
      true,
    );
  }

  function deselectCurrentMediaItem() {
    if (selectedItemIdx.value === null) {
      return;
    }
    toggleSelectedMedia(
      getMediaItemByMediaIdx(selectedItemIdx.value),
      mediaItemRefs.value[selectedItemIdx.value]?.firstElementChild,
      false,
    );
  }

  function isSelected(item) {
    return !!item.selected;
  }

  function onMediaItemClicked(event, item, offset = 0) {
    selectedItemIdx.value = item.idx;
    toggleSelectedMedia(item, event.currentTarget, null, offset);
  }

  function toggleSelectedMedia(
    media,
    htmlElement: HTMLElement | Element | null = null,
    val: null | boolean = null,
    offset = 0,
  ) {
    media.selected = val !== null ? val : !media.selected;

    if (htmlElement !== null) {
      if (offset > 0) {
        nextTick(() => {
          window.scroll({ top: getOffsetTop(htmlElement) - offset, behavior: 'smooth' });
        });
      } else {
        nextTick(() => {
          htmlElement.scrollIntoView({ behavior: 'smooth' });
        });
      }
    }
  }

  return {
    campsite,
    isSelected,
    mediaItemRefs,
    onKeyUp,
    onMediaItemClicked,
    selectedItemIdx,
  };
}
